import { jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo } from "react";
const chipMenuContext = createContext({
  open: false,
  setOpen: () => void 0
});
function ChipMenuContextProvider(props) {
  const { open, setOpen, children } = props;
  const contextValue = useMemo(
    () => ({
      open,
      setOpen
    }),
    [open, setOpen]
  );
  return /* @__PURE__ */ jsx(chipMenuContext.Provider, { value: contextValue, children });
}
function useChipMenu() {
  const { setOpen, ...rest } = useContext(chipMenuContext);
  const wrapWithOnClose = useCallback(
    (fn) => {
      return (...args) => {
        fn(...args);
        setOpen(false);
      };
    },
    [setOpen]
  );
  const onToggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, [setOpen]);
  const onClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const onOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);
  return {
    wrapWithOnClose,
    setOpen,
    onToggle,
    onClose,
    onOpen,
    ...rest
  };
}
export {
  ChipMenuContextProvider,
  useChipMenu
};
//# sourceMappingURL=ChipMenuContextProvider.js.map
